const FA = ()=> {
    return <div className="title">2FA</div>
}

export default FA;